import {
  HL_SLIPPAGE_DEFAULT_MODE,
  resolveHlSlippageBps,
} from './hlSlippage';

const STORAGE_KEY = 'singleAssetHlSlippage';

const DEFAULTS = {
  mode: HL_SLIPPAGE_DEFAULT_MODE,
  customPct: '10',
};

export function loadHlSlippageSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      mode: parsed.mode || DEFAULTS.mode,
      customPct: parsed.customPct != null ? String(parsed.customPct) : DEFAULTS.customPct,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveHlSlippageSettings(settings) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      mode: settings.mode || DEFAULTS.mode,
      customPct: settings.customPct != null ? String(settings.customPct) : DEFAULTS.customPct,
    })
  );
}

export function resolveStoredHlSlippageBps() {
  const { mode, customPct } = loadHlSlippageSettings();
  return resolveHlSlippageBps(mode, customPct);
}
